"use strict";

import _ from "underscore";

export default class AuthorController {
  /*@ngInject*/
  constructor(ElasticAPI, ProductAPI, LanguageService) {
    let that = this;
    this.ElasticAPI = ElasticAPI;
    this.ls = LanguageService;
    this.products = [];
    this.results = [];
    this.rawResults = [];
    this.enabled = false;

    ProductAPI.getModels()
      .$promise.then(function (response) {
        response = JSON.parse(JSON.stringify(response));
        for (let r in response) {
          that.products.push({
            id: response[r].id,
            nameFr: response[r].nameFr,
            nameEn: response[r].nameEn,
            rightId: response[r].rightId,
          });
        }
        if (that.products && that.products.length > 0) {
          that.selectedProduct = that.products[0];
        }
        return;
      })
      .catch(() => {
        console.log("---> Error on load products type");
      });
  }

  productChanged() {
    this.applyUse();
  }

  searchAuthorsKeyDown() {
    if (event.keyCode == 13 && this.query && this.query.length > 1) {
      this.searchAuthors(this.query);
    }
  }

  applyUse() {
    let that = this;
    this.results = [];
    if (this.selectedProduct && this.rawResults && this.rawResults.length > 0) {
      let results = JSON.parse(JSON.stringify(this.rawResults));
      for (var r in results) {
        let detail = results[r].detail;
        results[r].isManaged =
          _.pluck(detail.rights, "right_id").indexOf(
            that.selectedProduct.rightId
          ) != -1;
        results[r].label = `${detail.firstname || ""} ${
          detail.lastname || ""
        } ${detail.birth_year || detail.decease_year ? "(" : ""}${
          detail.birth_year || " "
        }${detail.decease_year ? ` - ${detail.decease_year}` : ""}${
          detail.birth_year || detail.decease_year ? ")" : ""
        }`;
        results[r].label = results[r].label.trim();
        results[r].copyright = detail.copyright;
        /*let rights = _.pluck(detail.rights, 'right_id');
        results[r].managedEn = [];
        results[r].managedFr = [];
        results[r].notManagedEn = [];
        results[r].notManagedFr = [];
        results[r].label = `${detail.firstname || ''} ${detail.lastname || ''} ${
          detail.birth_year || detail.decease_year ? '(' : ''
        }${detail.birth_year || ' '}${detail.decease_year ? ` - ${detail.decease_year}` : ''
        }${detail.birth_year || detail.decease_year ? ')' : ''}`;
        results[r].label = results[r].label.trim();

        for(let p in that.products){
          if(rights.indexOf(that.products[p].rightId)!==-1){
            results[r].managedEn.push(that.products[p].nameEn);
            results[r].managedFr.push(that.products[p].nameFr);
          }else{
            results[r].notManagedEn.push(that.products[p].nameEn);
            results[r].notManagedFr.push(that.products[p].nameFr);
          }
        }
        */
      }
      //console.log(results);
      that.results = results;
    }
  }

  searchAuthors(query) {
    this.results = null;
    this.enabled = false;
    this._query = this.query;
    let that = this;
    if (this.query && this.query.length > 1 && this.products.length > 0) {
      return this.ElasticAPI.searchAuthors(
        { name: this.query },
        function (results) {
          return results;
        }
      ).$promise.then(function (results) {
        results = JSON.parse(JSON.stringify(results));
        that.rawResults = JSON.parse(JSON.stringify(results));
        that.applyUse();
        that.enabled = true;
        return;
      });
    } else {
      return;
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/author/author.controller.js